export const FETCH_USER_TYPE_REQUEST    =   'FETCH_USER_TYPE_REQUEST '
export const FETCH_USER_TYPE_FAILURE   =   'FETCH_USER_TYPE_FAILURE '
export const FETCH_USER_TYPE_SUCCESS    =   'FETCH_USER_TYPE_SUCCESS '
